import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "advertising-row__header" }
const _hoisted_2 = { class: "advertising-row__type" }
const _hoisted_3 = { class: "advertising-row__desc" }
const _hoisted_4 = { class: "advertising-row__actions" }
const _hoisted_5 = {
  key: 0,
  class: "advertising-row__loading-tip"
}

import {
  useBaseAsync,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import AdvertisingItem from './AdvertisingItem.vue';
import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertisingRow',
  props: {
    rowData: {},
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const loading = ref(false);
const deleteDialogVisible = ref(false);

const props = __props;

const addDialogRef = ref<{ reset?(): void; setOneFormState?(name: string, value: unknown): void }>();

const typeOp: {
    value: any;
    label: string;
}[] = [
  {
    label: '小程序',
    value: 'weapp',
  },
  {
    label: '公众号文章',
    value: 'wx',
  },
];

const items: HpsfirProFormItem[] = [
  {
    name: 'image',
    label: '图片',
    rule: [{ required: true }],
    type: 'image',
    action: useApi().uploadImageUrl,
    multiple: false,
    onSuccess(data) {
      console.log(data.data[0]);
      addDialogRef.value?.setOneFormState('image', data.data[0]);
    },
  },
  {
    type: 'select',
    label: '类型',
    name: 'type',
    options: typeOp,
    rule: [{ required: true }],
  },
  {
    type: 'string',
    label: 'URL/Path',
    name: 'url',
    rule: [{ required: true }],
  },
  {
    type: 'string',
    label: 'appid',
    name: 'appid',
  },
];

const datas = ref<any[]>([]);

const emits = __emit;

function withTimeout<T>(promise: Promise<T>, message = '广告数据加载超时') {
  return Promise.race([
    promise,
    new Promise<T>((resolve, reject) => {
      void resolve;
      window.setTimeout(() => reject(new Error(message)), 15000);
    }),
  ]);
}

const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const res = await withTimeout(useApi().advertisingApi.listAdvertisingadvertising({
      conditions: {
        rowId: props.rowData.id,
      },
    }));
    datas.value = res?.data?.data || [];
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '广告数据加载失败');
  } finally {
    loading.value = false;
  }
});

const moveRow = useBaseAsync(async(type: 'up' | 'down') => {
  try {
    loading.value = true;
    await withTimeout(useApi().advertisingApi.moveAdvertisingRowadvertising({
      advertisingRowId: props.rowData.id,
      up: type === 'up',
    }), '移动广告行超时');
    emits('change');
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '移动广告行失败');
  } finally {
    loading.value = false;
  }
});

const openDeleteDialog = () => {
  deleteDialogVisible.value = true;
};

const confirmDeleteRow = async() => {
  try {
    loading.value = true;
    await withTimeout(useApi().advertisingApi.delAdvertisingRowadvertising(props.rowData.id), '删除广告行超时');
    deleteDialogVisible.value = false;
    ElMessage.success('删除成功');
    emits('change');
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '删除广告行失败');
  } finally {
    loading.value = false;
  }
};

const handleAdd = useBaseAsync(async(data: any) => {
  try {
    await withTimeout(useApi().advertisingApi.addAdvertisingadvertising({
      advertisingAdminVo: {
        rowId: props.rowData.id,
        sequence: datas.value.length + 1,
        ...data,
      },
    }), '添加广告超时');
    ElMessage.success('添加成功');
    addDialogRef.value?.reset();
    init();
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '添加广告失败');
  }
});

init();

return (_ctx: any,_cache: any) => {
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["advertising-row", loading.value ? 'advertising-row--loading' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.rowData.type === 'carousel' ? '轮播广告' : '均匀分布广告'), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.rowData.type === 'carousel' ? '多条广告按顺序轮播展示' : '多条广告在同一行均匀展示'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!__props.isFirst)
          ? (_openBlock(), _createBlock(_component_HpsfirButton, {
              key: 0,
              variant: "outline",
              size: "sm",
              onClick: _cache[0] || (_cache[0] = () => _unref(moveRow)('up'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowUpBold)
                  ]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createTextVNode(" 上移 ", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!__props.isLast)
          ? (_openBlock(), _createBlock(_component_HpsfirButton, {
              key: 1,
              variant: "outline",
              size: "sm",
              onClick: _cache[1] || (_cache[1] = () => _unref(moveRow)('down'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDownBold)
                  ]),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createTextVNode(" 下移 ", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "advertising-row__action-btn advertising-row__action-btn--danger",
          type: "button",
          onClick: _withModifiers(openDeleteDialog, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Delete)
            ]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createTextVNode(" 删除 ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["advertising-row__content", __props.rowData.type === 'distribute' ? 'advertising-row__content--grid' : 'advertising-row__content--list'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value, (item, inx) => {
        return (_openBlock(), _createBlock(AdvertisingItem, {
          key: item.id,
          data: item,
          "is-first": inx === 0,
          "is-last": inx === datas.value.length - 1,
          "is-h": __props.rowData.type === 'distribute',
          onChange: _cache[2] || (_cache[2] = () => _unref(init)())
        }, null, 8, ["data", "is-first", "is-last", "is-h"]))
      }), 128)),
      _createElementVNode("button", {
        class: "advertising-row__add-item",
        type: "button",
        onClick: _cache[3] || (_cache[3] = () => addDialogRef.value?.showDialog())
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Plus)
          ]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createTextVNode(" 添加一条广告 ", -1))
      ])
    ], 2),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "处理中..."))
      : _createCommentVNode("", true),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "addDialogRef",
      ref: addDialogRef,
      title: "添加一条",
      items: items,
      onOk: _unref(handleAdd)
    }, null, 8, ["onOk"]),
    _createVNode(_component_HpsfirProDrawer, {
      open: deleteDialogVisible.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((deleteDialogVisible).value = $event)),
      title: "删除广告行",
      width: "420px",
      "max-width": "calc(100vw - 32px)"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_HpsfirButton, {
          variant: "outline",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_HpsfirButton, {
          variant: "destructive",
          loading: loading.value,
          onClick: confirmDeleteRow
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("确定删除", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "advertising-row__delete-confirm" }, [
          _createElementVNode("div", { class: "advertising-row__delete-title" }, "确定要删除这一行广告吗？"),
          _createElementVNode("div", { class: "advertising-row__delete-desc" }, "该行下的广告条目也会被删除，删除后无法恢复，请谨慎操作。")
        ], -1))
      ]),
      _: 1
    }, 8, ["open"])
  ], 2))
}
}

})